import Vue from 'vue'

/* left menu */
import LeftMenu from '@/components/Doc/left-menu/TheLeftMenu.component.vue'

Vue.component('doc-leftmenu', LeftMenu)
